import MdIcon from './MdIcon';
export const mdIconDefine = (app) => {
  app.component(MdIcon.name, MdIcon);
};
